import {get} from "lodash"
import {
    DepartmentChatRouting,
    DepartmentChatRoutingListPayload,
    DepartmentChatRoutingSavePayload,
    DepartmentChatRoutingSubunitAccessPayload,
    DepartmentChatSubunitAccess
} from "types/departmentChatRouting"
import BaseService from "./Base"

class DepartmentChatRoutingService extends BaseService {
    list = async (payload: DepartmentChatRoutingListPayload = {}): Promise<DepartmentChatRouting[]> => {
        const response = await this.post("/v1/settings/department-chat-routing/list", payload)
        return get(response, "data.data", [])
    }

    getSubunitAccess = async (
        payload: DepartmentChatRoutingSubunitAccessPayload
    ): Promise<DepartmentChatSubunitAccess[]> => {
        const response = await this.post("/v1/settings/department-chat-routing/subunit-access", payload)
        return get(response, "data.data", [])
    }

    save = async (payload: DepartmentChatRoutingSavePayload): Promise<DepartmentChatRouting> => {
        const response = await this.post("/v1/settings/department-chat-routing/save", payload)
        return get(response, "data.data")
    }
}

export default DepartmentChatRoutingService
